import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

interface DeleteRecommendationsResponse {
  carePlan: fhirTypes.CarePlan;
  recommendations: fhirTypes.Task[];
}

export const useDeleteRecommendations = ({
  encounterId,
  carePlanId,
}: {
  encounterId: string;
  carePlanId: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<DeleteRecommendationsResponse, void>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.VOID({
          patientId,
          encounterId,
          carePlanId,
        }),
      mutationFn: () => {
        return axiosInstance.delete(
          `/charting/careplan/${carePlanId}/recommendations/`,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.DEFAULT(
              {
                patientId,
                encounterId,
                carePlanId,
              },
            ),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
